import { GProductFavorite } from '@gazin/ecommerce-ui'
import { FavoriteProductMethod } from 'src/components/conteudoFavoritos/types'
import { Favorito } from 'src/contexto/types'
import { getFavoriteStoreKey } from 'src/util/favorite'

type ProductContentFavoriteButtonProps = {
  color: string
  product_id: number
  product_url: string
  voltage: string
  favoritesStore: Favorito[]
  favoriteProduct: FavoriteProductMethod
}

export default function ProductContentFavoriteButton({
  color,
  product_id,
  product_url,
  voltage,
  favoritesStore,
  favoriteProduct,
}: ProductContentFavoriteButtonProps) {
  const favoriteStoreKey = getFavoriteStoreKey(
    favoritesStore,
    product_id,
    color,
    voltage
  )

  return (
    <GProductFavorite
      data-testid="favorite-button"
      h={6}
      onClick={() =>
        favoriteProduct(
          product_url,
          product_id,
          color,
          voltage,
          favoriteStoreKey
        )
      }
      variant={`${favoriteStoreKey >= 0 ? 'filled' : 'outline'}`}
      w={6}
    />
  )
}
